import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useCallback, useState } from 'react';
import { LoadMoreRow } from './style';

interface Data {
  pageInfo?: {
    endCursor?: string | null;
    hasNextPage?: boolean;
  };
}

interface FetchMoreOptions {
  variables: {
    after?: string | null;
    isFirstPage: boolean;
  };
}

interface LoadMoreProps {
  data?: Data;
  // eslint-disable-next-line no-unused-vars typescript/no-explicit-any
  fetchMore: (options: FetchMoreOptions) => Promise<any>;
  loading?: boolean;
  style?: React.CSSProperties;
  size?: 'small' | 'middle' | 'large';
}

const LoadMore = function ({
  data,
  fetchMore,
  loading = false,
  style,
  size,
}: LoadMoreProps) {
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const getNextPage = useCallback(async () => {
    if (isLoadingMore) return;
    setIsLoadingMore(true);
    await fetchMore({
      variables: {
        after: data?.pageInfo?.endCursor,
        isFirstPage: false,
      },
    });
    setIsLoadingMore(false);
  }, [data, fetchMore, isLoadingMore]);

  const hasNextPage = data?.pageInfo?.hasNextPage;
  if (!hasNextPage) {
    return null;
  }

  return (
    <LoadMoreRow type="flex" justify="center" style={style}>
      <Button
        disabled={isLoadingMore || loading}
        loading={isLoadingMore || loading}
        type="primary"
        icon={<DownloadOutlined />}
        onClick={getNextPage}
        size={size}
      >
        Load more
      </Button>
    </LoadMoreRow>
  );
};

export default LoadMore;
